import * as LanguageManager from "../LanguageManager";

import { action, thunk, thunkOn } from "easy-peasy";

import { LanguageModelInterface } from "./languageModelInterface";

const languagesModel: LanguageModelInterface = {
  items: [],
  activeItems: [],
  selectedLanguage: undefined,
  formDefaultLanguage: undefined,
  selectedAppLanguage: "",
  setFormDefaultLanguage: action((state, payload) => {
    state.formDefaultLanguage = payload;
  }),
  setActiveItems: action((state, payload) => {
    state.activeItems = payload;
  }),
  setItems: action((state, payload) => {
    state.items = payload.map((item) => item);
  }),
  getItems: thunk(async (action, payload, { getStoreActions }) => {
    const { loading } = getStoreActions();
    try {
      loading.setLoading(true);
      const languages = await LanguageManager.getLanguages(payload);
      action.setItems(languages);
    } catch (error) {
      action.setItems([]);
    } finally {
      loading.setLoading(false);
    }
  }),
  selectLanguage: action((state, payload) => {
    if (payload) state.selectedLanguage = payload;
  }),
  updateLanguage: thunk((actions, payload, { getStoreActions }) => {
    const { form, sections, fields } = getStoreActions();
    form.updateTranslation(payload);
    sections.updateSectionTranslation(payload);
    fields.updateFieldTitleTranslation(payload);
    fields.updateOptionTranslation(payload);
  }),
  setSelectedAppLanguage: action((state, payload) => {
    state.selectedAppLanguage = payload?.isoCode ?? "";
  }),
  onFormLanguageChange: thunkOn(
    (actions, storeActions) => [
      // the selectLanguage and setFormDefaultLanguage actions are all called on formActions already, so the only action that needs to be listened here is the updateLanguage action
      storeActions.languages.updateLanguage,
    ],
    async (actions, target) => {
      actions.notifyLanguageChange(target);
    }
  ),
  notifyLanguageChange: action((state, payload) => {}),
};

export default languagesModel;
